<template>
  <v-navigation-drawer
    persistent
    :mini-variant="$store.state.layout.miniVariant"
    :clipped="clipped"
    v-model="$store.state.layout.drawer"
    enable-resize-watcher
    fixed
    class="app-sidenav"
    app
    width="350"
    mini-variant-width="68"
  >
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
    />
    <v-tooltip bottom>
      <div class="app-logo" slot="activator" @click="sendInicio()">
        <h1 class="app-title">
          <v-icon>dashboard</v-icon><span>{{ $t("app.title") }}</span>
        </h1>
      </div>
      <span>Inicio</span>
    </v-tooltip>
    <v-list id="sidenav-menu">
      <v-list-group
        v-model="item.active"
        v-for="item in menu"
        :key="item.id"
        :prepend-icon="item.icono"
        v-if="item.children.length > 0"
        class="sidenav-parent"
        no-action
      >
        <v-list-tile
          slot="activator"
          @click.stop="toggleGroup(item)"
          :data-url="item.url"
        >
          <v-list-tile-content>
            <v-list-tile-title class="font-weight-bold">{{
                getLabel(item)
              }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          v-for="subItem in item.children"
          :key="subItem.id"
          @click="send(subItem.ruta)"
          :data-url="subItem.ruta"
          class="sidenav-children"
        >
          <span class="material-symbols-outlined span-icon">
            {{ subItem.icono }}
          </span>
          <v-list-tile-content class="pl-2">
            <v-tooltip bottom close-delay="0">
              <v-list-tile-title slot="activator">{{
                  getLabel(subItem)
                }}</v-list-tile-title>
              <span>{{ getLabel(subItem) }}</span>
            </v-tooltip>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <v-list-tile
        v-else
        @click="send(item.ruta)"
        :data-url="item.ruta"
        class="sidenav-one"
      >
        <v-list-tile-action>
          <span class="material-symbols-outlined span-icon">
            {{ item.icono }}
          </span>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title :class="item.ruta ? '' : 'font-weight-bold'">
            {{ getLabel(item) }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import layout from "./mixins/layout";

export default {
  mixins: [layout],
  mounted() {
    if (this.$storage.exist("menu")) {
      this.$store.commit("setMenu", this.$storage.get("menu"));
    }

    if (this.$storage.existUser()) {
      this.$store.commit("setUser", this.$storage.getUser());
    }

    this.setActive(this.$route.path);
    setTimeout(() => {
      this.clickEvent(this.$route.path);
      this.scrollToActiveItem();
    }, 600);

    // Detectar cuando el usuario hace scroll manualmente
    this.$nextTick(() => {
      const sidenavMenu = document.querySelector('#sidenav-menu');
      if (sidenavMenu) {
        sidenavMenu.addEventListener('scroll', this.handleUserScroll);
      }
    });
  },
  beforeDestroy() {
    // Limpiar el event listener
    const sidenavMenu = document.querySelector('#sidenav-menu');
    if (sidenavMenu) {
      sidenavMenu.removeEventListener('scroll', this.handleUserScroll);
    }
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  },
  updated() {
    // Solo hacer scroll automático si el usuario no está navegando manualmente
    if (!this.userIsScrolling) {
      this.$nextTick(() => {
        this.scrollToActiveItem();
      });
    }
  },
  data: () => ({
    clipped: false,
    userIsScrolling: false,
    scrollTimeout: null
  }),
  computed: {
    ...mapState(["menu", "user"]),
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    }
  },
  methods: {
    toggleGroup(item) {
      // Solo expandir/colapsar el grupo, sin navegar
      this.$set(item, 'active', !item.active);

      // Marcar que el usuario está interactuando con el menú
      this.userIsScrolling = true;

      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        this.userIsScrolling = false;
      }, 1500);
    },
    handleUserScroll() {
      // Marcar que el usuario está haciendo scroll manualmente
      this.userIsScrolling = true;

      // Resetear después de 2 segundos de inactividad
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        this.userIsScrolling = false;
      }, 2000);
    },
    scrollToActiveItem() {
      // Solo hacer scroll si el usuario no está navegando manualmente
      if (this.userIsScrolling) {
        return;
      }

      // Buscar el elemento activo en el menú
      this.$nextTick(() => {
        const activeElement = document.querySelector('#sidenav-menu .v-list__tile--link.active');

        if (activeElement) {
          // Scroll suave hacia el elemento activo
          activeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
          });
        }
      });
    },
    sendInicio() {
      this.$router.push("/").catch(err => {});
      // Para cerrar menu
      if (this.breakpoint != "xs") {
        if (!this.$store.state.layout.miniVariant) {
          this.$store.commit("layout/toggleMiniVariant");
        }
      }

      // Permitir scroll automático al ir a inicio
      this.userIsScrolling = false;

      // Scroll al inicio cuando se va a la página principal
      this.$nextTick(() => {
        const sidenavMenu = document.querySelector('#sidenav-menu');
        if (sidenavMenu) {
          sidenavMenu.scrollTop = 0;
        }
      });
    },
    send(url, sw_cerrar_menu) {
      if (url && url !== "/") {
        if (this.$storage.exist("menu")) {
          let page = this.$util.getMenuOption(this.$storage.get("menu"), url);
          this.$store.commit("layout/setBreadcrumbs", page);
        }

        this.setActive(url);

        this.$router.push("/" + (url || "")).catch(err => {});

        // Permitir scroll automático solo después de hacer click
        this.userIsScrolling = false;

        // Scroll al item activo después de la navegación
        setTimeout(() => {
          this.scrollToActiveItem();
        }, 100);

        // Para cerrar menu
        if (this.breakpoint != "xs") {
          if (!this.$store.state.layout.miniVariant) {
            this.$store.commit("layout/toggleMiniVariant");
          }
        }
      }
    },
    getLabel(item) {
      return item.descripcion;
    }
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/_variables.scss";

// Colores mejorados - más claros y con mejor contraste
$bgSidenav: #2c3e50;  // Fondo más claro
$bgSidenavDark: #243342;  // Variante más oscura para contraste
$colorHover: rgba(52, 152, 219, 0.15);  // Hover sutil pero visible
$colorActive: #3498db;  // Color activo más brillante
$colorActiveBg: rgba(52, 152, 219, 0.25);  // Fondo del item activo
$colorText: #ecf0f1;  // Texto claro
$colorTextSecondary: #bdc3c7;  // Texto secundario
$colorIconPadre: #3498db;  // Iconos padres azul brillante
$colorIconHijo: #5dade2;  // Iconos hijos azul más claro
$borderActive: #2ecc71;  // Borde verde para item activo

.theme--light .app-sidenav {
  letter-spacing: -0.3px;
  background-color: $bgSidenav !important;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);

  .v-navigation-drawer__border {
    display: none !important;
  }

  .v-list {
    background-color: $bgSidenav;
    padding: 8px 0;
    overflow-y: auto;
    scroll-behavior: smooth;
  }

  // ITEM ACTIVO - Mucho más visible
  .v-list .v-list__tile--link.active {
    background: linear-gradient(90deg, $colorActiveBg 0%, rgba(52, 152, 219, 0.1) 100%);
    border-left: 4px solid $borderActive;
    box-shadow: inset 0 0 10px rgba(46, 204, 113, 0.2);

    .v-list__tile__title {
      color: #fff !important;
      font-weight: 600;
    }

    .span-icon, .v-icon {
      color: $borderActive !important;
      filter: drop-shadow(0 0 3px rgba(46, 204, 113, 0.5));
    }
  }

  // Items hijos del grupo
  .v-list__group__items--no-action .v-list__tile {
    padding-left: 30px;
    margin: 2px 8px;
    border-radius: 4px;
    transition: all 0.2s ease;

    .span-icon {
      color: $colorIconHijo;
      font-size: 1.4em;
      transition: all 0.2s ease;
    }

    .v-icon {
      color: $colorIconHijo;
      transition: all 0.2s ease;
    }

    .v-list__tile__title {
      color: $colorText;
      font-size: 15px;
    }

    &:hover {
      background: $colorHover;
      transform: translateX(4px);

      .span-icon, .v-icon {
        color: lighten($colorIconHijo, 15%);
      }
    }
  }

  // Header del grupo padre
  .v-list__group__header {
    margin: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s ease;

    &:hover {
      background: $colorHover;
    }
  }

  .v-list__group__header__prepend-icon {
    padding: 0 4px 0 16px;

    & + div > .v-list__tile {
      padding-left: 4px;
    }
  }

  // Estilos generales de texto e iconos
  .v-list__tile.primary--text,
  .v-list__group,
  .sidenav-one .v-list__tile__content {
    color: $colorText;

    .v-icon {
      color: $colorIconPadre;
    }

    .v-list__tile__title {
      font-size: 16px;
      font-weight: 500;
    }
  }

  // Componente padre sin hijos
  .sidenav-one {
    margin: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s ease;

    .v-list__tile {
      &:hover {
        background: $colorHover;
        transform: translateX(4px);
      }
    }

    .v-list__tile__action {
      min-width: 44px;

      .span-icon, .v-icon {
        color: $colorIconPadre;
        transition: all 0.2s ease;
      }
    }

    &:hover {
      .span-icon, .v-icon {
        color: lighten($colorIconPadre, 15%);
      }
    }
  }

  // Logo de la aplicación
  .app-logo {
    cursor: pointer;
    background: linear-gradient(135deg, $bgSidenavDark 0%, darken($bgSidenav, 5%) 100%);
    height: 60px;
    border-bottom: 3px solid rgba(52, 152, 219, 0.3);
    transition: all 0.3s ease;

    .v-icon {
      font-size: 1.3em;
      margin: -5px 8px 0 0;
      color: $colorIconPadre;
    }

    .app-title {
      color: $colorText;
      font-weight: 500;
      line-height: 60px;
      font-size: 1.6rem;
      padding: 0 15px;
      white-space: nowrap;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    &:hover {
      background: linear-gradient(135deg, lighten($bgSidenavDark, 5%) 0%, $bgSidenav 100%);
      border-bottom-color: rgba(52, 152, 219, 0.5);
    }
  }

  // Modo mini-variant
  &.v-navigation-drawer--mini-variant {
    overflow: initial;

    .app-title {
      span {
        display: none;
      }
    }

    .sidenav-one:hover {
      width: 280px;
      background-color: $bgSidenav;
      box-shadow: 2px 0 12px rgba(0, 0, 0, 0.2);

      .v-list__tile__action {
        margin-right: 30px;
      }
    }

    .v-list__tile__content {
      opacity: 1;
    }

    .v-list__group__items--no-action .v-list__tile {
      padding-left: 20px;
      padding-right: 20px;
    }

    .sidenav-parent {
      background-color: $bgSidenav;
      position: relative;
      height: 50px;

      &:hover {
        .v-list__group__header {
          background-color: $bgSidenav;
          width: 280px;
          height: 50px;
          box-shadow: 2px 0 12px rgba(0, 0, 0, 0.2);

          .v-list__tile--link {
            display: block;
          }
        }

        .v-list__group__items {
          border-top: 2px solid rgba(52, 152, 219, 0.3);
          background-color: $bgSidenav;
          display: block !important;
          position: absolute;
          z-index: 5;
          left: 70px;
          border-radius: 0 0 4px 4px;
          width: 210px;
          box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);

          .v-list__tile {
            height: 40px;
          }
        }
      }
    }

    .v-list {
      .sidenav-one .v-list__tile--link {
        padding: 10px 20px 10px 9px;
        height: 50px;
        background-color: $bgSidenav;
      }
    }

    .v-list__group__header {
      .v-list__group__header__prepend-icon {
        padding: 16px 0px 16px 20px;
        width: 68px;
        height: 50px;

        .v-icon {
          font-size: 2rem;
        }
      }

      .v-list__tile--link {
        display: none;
      }

      .v-list__group__header__append-icon {
        display: none;
      }
    }

    .v-list__group__items {
      display: none !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/layout/AppSidenav.vue